export const UPDATE_TRANSACTIONS = 'UPDATE_TRANSACTIONS';
export const OPEN_SOCKET_CONNECTION = 'OPEN_SOCKET_CONNECTION';
export const SOCKET_PAYMENT_SUBSCRIBER = 'SOCKET_PAYMENT_SUBSCRIBER';
export const SET_PAYMENT_REQUEST = 'SET_PAYMENT_REQUEST';
export const TOGGLE_SPINNER = 'TOGGLE_SPINNER';
export const RECHECK_FOR_PAYMENT = 'RECHECK_FOR_PAYMENT';